export const endPoints = {
  AUTO_TASK_SETTING: '/v1/auto-task-setting',
  LEAD_TASK_FILTER: '/v1/lead-task/filter',
  LEAD_TASK_FILTER_CALENDAR: '/v1/lead-task/filter-calendar',
  TABLE_VIEW_TASK: '/v1/lead-task/table/filter',
  TASK_EMPLOYEE: '/v1/lead-task/action/employee',
  TASK_TYPE: '/v1/lead-task/action/task-type',
  TASK_ACTIONS: '/v1/lead-task/action'
};
